var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-wrapper',{attrs:{"isSpinner":_vm.isSpinner}},[(_vm.servicesData.Calltracking !== 2)?_c('call-tracking-description'):_c('call-tracking-connected',{attrs:{"rules":_vm.rules,"classes":_vm.classes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }